
<manage-wrapper
  *ngIf="!!entity"
  [canEditMain]="true"
  [entityTitle]="entity.name"
  [tabGroups]="tabGroups"
  [hideLabels]="true"
  [selectedTab]="selectedTab"
  [readOnly]="false"
  [deleteTitle]="'Delete this asset template'"
  [titlePlaceholder]="'Asset template name...'"
  [backgroundColor]="'#41474F'"
  [dialogTitle]="'Clipboard Asset Details'"
  [canDuplicate]="false"
  [type]="'asset'"
  (onDone)="exit()"
  (onChangeTab)="changeTab($event)"
  (onDelete)="delete()"
  (saveTitle)="updateTitle($event)"
>
<div class="afterTitle">
  <menu-hover-button [readOnly]="readOnly" id="iconButton" [iconSelector]="entity.icon"
    [hoverText]="'Choose asset type'" [text]="!entity.icon ? 'Type' : null" 
    [lightText]="!entity.icon" (click)="readOnly ? null : setIcon()"></menu-hover-button>
</div>

  <ng-container *ngIf="!selectedTab || selectedTab?.id === 'details'">
    
    <title-icon [title]="'Asset description'" [titleIcon]="'description18'"></title-icon>
    <joi-input style="margin-bottom: 40px" [disabled]="readOnly" [italicPlaceholder]="true" [(model)]="entity.description" [type]="'textarea'" [returnable]="true" [placeholder]="'Click to add asset description...'" (joiChange)="saveEntity()"></joi-input>
    
    <title-icon [title]="'Link to asset URL'" [titleIcon]="'LINK18'"></title-icon>
    <joi-input style="margin-bottom: 40px" [disabled]="readOnly" [italicPlaceholder]="true" [(model)]="entity.link" [type]="'textarea'" [returnable]="true" [placeholder]="'Click to add asset description...'" (joiChange)="saveEntity()"></joi-input>

  </ng-container>
</manage-wrapper>